import { calculatePointValue } from '../token.helpers'
import { EXCHANGE_TRANSACTION_TYPES } from '../../constants/transactionTypes'
import { addNumbers, percentageOfCompletion } from '../number.helpers'

const buildTransferVolumeData = (
  { exchangeInTxValue, exchangeOutTxValue },
  exchangeType
) => {
  switch (exchangeType) {
    case EXCHANGE_TRANSACTION_TYPES.BUY:
      return {
        data: [exchangeOutTxValue, 0]
      }
    case EXCHANGE_TRANSACTION_TYPES.SELL:
      return {
        data: [0, exchangeInTxValue]
      }
    default:
      return {
        data: [exchangeOutTxValue, exchangeInTxValue]
      }
  }
}

const buildTransactionsCountData = (
  { exchangeInTxCount, exchangeOutTxCount },
  exchangeType
) => {
  switch (exchangeType) {
    case EXCHANGE_TRANSACTION_TYPES.BUY:
      return {
        data: [exchangeOutTxCount, 0]
      }

    case EXCHANGE_TRANSACTION_TYPES.SELL:
      return {
        data: [0, exchangeInTxCount]
      }

    default:
      return {
        data: [exchangeOutTxCount, exchangeInTxCount]
      }
  }
}

const buildTransactionsRateData = (
  {
    exchangeInTxValue,
    exchangeOutTxValue,
    exchangeInTxCount,
    exchangeOutTxCount
  },
  exchangeType
) => {
  switch (exchangeType) {
    case EXCHANGE_TRANSACTION_TYPES.BUY:
      return {
        data: [exchangeOutTxValue / exchangeOutTxCount, 0]
      }

    case EXCHANGE_TRANSACTION_TYPES.SELL:
      return {
        data: [0, exchangeInTxValue / exchangeInTxCount]
      }

    default:
      return {
        data: [
          exchangeOutTxValue / exchangeOutTxCount,
          exchangeInTxValue / exchangeInTxCount
        ]
      }
  }
}

const buildTransactionsValueData = (
  { exchangeInTxValue, exchangeOutTxValue },
  { offramp, onramp },
  exchangeType
) => {
  switch (exchangeType) {
    case EXCHANGE_TRANSACTION_TYPES.BUY:
      return {
        data: [calculatePointValue(exchangeOutTxValue, offramp), 0]
      }
    case EXCHANGE_TRANSACTION_TYPES.SELL:
      return {
        data: [0, calculatePointValue(exchangeInTxValue, onramp)]
      }

    default:
      return {
        data: [
          calculatePointValue(exchangeOutTxValue, offramp),
          calculatePointValue(exchangeInTxValue, onramp)
        ]
      }
  }
}

const calculateExchangeMembers = (members, exchangeType) => {
  if (exchangeType === EXCHANGE_TRANSACTION_TYPES.ALL) {
    return members.buy + members.sell
  }
  return members[exchangeType]
}

const formatExchangePartners = (data, exchangeType) => {
  let firstExchangeValue
  return data
    .map(({ brand, token, ...restAttrs }) => {
      const exchangeData = formatExchangePartnerData(restAttrs, exchangeType)
      return { ...exchangeData, brand, token }
    })
    .filter(({ value }) => value > 0)
    .sort((a, b) => b?.value - a?.value)
    .slice(0, 10)
    .map(({ value, ...restAttrs }, index) => {
      let percentage = 0
      if (index === 0) {
        firstExchangeValue = value
        percentage = 100
      } else {
        percentage = value && percentageOfCompletion(value, firstExchangeValue)
      }
      return { ...restAttrs, value, percentage }
    })
}

const formatExchangePartnerData = (
  {
    exchangeInTxValue,
    exchangeOutTxValue,
    exchangeInTxCount,
    exchangeOutTxCount
  },
  exchangeType
) => {
  switch (exchangeType) {
    case EXCHANGE_TRANSACTION_TYPES.BUY:
      return {
        value: exchangeOutTxValue,
        count: exchangeOutTxCount
      }
    case EXCHANGE_TRANSACTION_TYPES.SELL:
      return {
        value: exchangeInTxValue,
        count: exchangeInTxCount
      }

    default:
      return {
        value: addNumbers(exchangeOutTxValue, exchangeInTxValue),
        count: addNumbers(exchangeOutTxCount, exchangeInTxCount)
      }
  }
}

export {
  buildTransferVolumeData,
  buildTransactionsCountData,
  buildTransactionsRateData,
  buildTransactionsValueData,
  calculateExchangeMembers,
  formatExchangePartners,
  formatExchangePartnerData
}
